import React, { useState, useEffect } from 'react';
import { getMerchant } from '../services/api';

const ApiDebug = () => {
  const [debugInfo, setDebugInfo] = useState({});
  const [testResult, setTestResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // 收集調試信息
    const info = {
      userAgent: navigator.userAgent,
      apiUrl: process.env.REACT_APP_API_URL,
      currentUrl: window.location.href,
      timestamp: new Date().toISOString(),
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    };
    setDebugInfo(info);
  }, []);

  const testApiConnection = async () => {
    setLoading(true);
    setTestResult(null);
    
    try {
      console.log('Testing API connection...');
      
      // 先測試直接的 fetch 請求
      const directUrl = `${window.location.origin}/api/merchants/kaka-booking/`;
      console.log('Testing direct fetch to:', directUrl);
      
      const fetchResponse = await fetch(directUrl);
      console.log('Direct fetch response:', fetchResponse.status, fetchResponse.statusText);
      
      if (!fetchResponse.ok) {
        throw new Error(`Direct fetch failed: ${fetchResponse.status} ${fetchResponse.statusText}`);
      }
      
      const fetchData = await fetchResponse.json();
      console.log('Direct fetch data:', fetchData);
      
      // 然後測試通過 API service
      const response = await getMerchant('kaka-booking');
      console.log('API service test successful:', response.data);
      
      setTestResult({
        success: true,
        data: response.data,
        directFetch: fetchData,
        message: 'API 連接成功！'
      });
    } catch (error) {
      console.error('API test failed:', error);
      
      // 嘗試更詳細的錯誤診斷
      let errorDetails = {
        message: error.message,
        name: error.name,
        stack: error.stack
      };
      
      if (error.response) {
        errorDetails.response = {
          status: error.response.status,
          statusText: error.response.statusText,
          data: error.response.data,
          headers: error.response.headers
        };
      }
      
      if (error.request) {
        errorDetails.request = {
          readyState: error.request.readyState,
          status: error.request.status,
          responseURL: error.request.responseURL
        };
      }
      
      setTestResult({
        success: false,
        error: error.message,
        details: errorDetails,
        status: error.response?.status || 'No status',
        message: 'API 連接失敗'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">API 連接調試</h1>
        
        {/* 設備信息 */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">設備信息</h2>
          <div className="space-y-2 text-sm">
            <div><strong>設備類型:</strong> {debugInfo.isMobile ? '手機' : '電腦'}</div>
            <div><strong>API URL:</strong> {debugInfo.apiUrl}</div>
            <div><strong>當前 URL:</strong> {debugInfo.currentUrl}</div>
            <div><strong>時間:</strong> {debugInfo.timestamp}</div>
          </div>
          <details className="mt-4">
            <summary className="cursor-pointer text-blue-600">顯示 User Agent</summary>
            <div className="mt-2 p-2 bg-gray-100 rounded text-xs break-all">
              {debugInfo.userAgent}
            </div>
          </details>
        </div>

        {/* API 測試 */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">API 連接測試</h2>
          <button
            onClick={testApiConnection}
            disabled={loading}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? '測試中...' : '測試 API 連接'}
          </button>
          
          {testResult && (
            <div className={`mt-4 p-4 rounded ${testResult.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
              <h3 className={`font-semibold ${testResult.success ? 'text-green-800' : 'text-red-800'}`}>
                {testResult.message}
              </h3>
              
              {testResult.success ? (
                <div className="mt-2">
                  <p className="text-green-700">商戶名稱: {testResult.data.name}</p>
                  <p className="text-green-700">商戶 ID: {testResult.data.id}</p>
                </div>
              ) : (
                <div className="mt-2 space-y-2">
                  <p className="text-red-700">錯誤: {testResult.error}</p>
                  <p className="text-red-700">狀態碼: {testResult.status}</p>
                  <details>
                    <summary className="cursor-pointer text-red-600">詳細錯誤信息</summary>
                    <pre className="mt-2 p-2 bg-red-100 rounded text-xs overflow-auto">
                      {JSON.stringify(testResult.details, null, 2)}
                    </pre>
                  </details>
                </div>
              )}
            </div>
          )}
        </div>

        {/* 返回首頁 */}
        <div className="text-center">
          <a href="/kaka-booking" className="text-blue-600 hover:text-blue-800">
            返回首頁
          </a>
        </div>
      </div>
    </div>
  );
};

export default ApiDebug;